import { render, staticRenderFns } from "./VInventoryItemHolderActionModal.vue?vue&type=template&id=c0e7dab0"
import script from "./VInventoryItemHolderActionModal.vue?vue&type=script&lang=js"
export * from "./VInventoryItemHolderActionModal.vue?vue&type=script&lang=js"
import style0 from "./VInventoryItemHolderActionModal.vue?vue&type=style&index=0&id=c0e7dab0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports